export default __webpack_public_path__ + "static/media/Layer_47.6113393b.svg";